module.exports = __webpack_public_path__ + "27d6eaaf226ebe0dee289955a3d71b55.pdf";